import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel } from '@mui/material';

type DisclaimerCheckboxProps = {
  checked: boolean;
  message: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  containerStyle?: string;
  disclaimerHeaderText?: string;
  id?: string;
};

export default function DisclaimerCheckbox({
  containerStyle,
  checked,
  disclaimerHeaderText,
  message,
  disabled,
  onChange,
  required,
  id,
}: DisclaimerCheckboxProps) {
  const { t } = useTranslation();

  return (
    <div className={containerStyle}>
      {disclaimerHeaderText && <p>{t(disclaimerHeaderText)}</p>}

      <FormControlLabel
        control={(
          <Checkbox
            id={id ?? 'disclaimer-checkbox'}
            color="primary"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            required={required}
          />
        )}
        label={t(message)}
      />
    </div>
  );
}
